import React from 'react';
import PropTypes from 'prop-types';

const HamburgerIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 16"
      width="25"
      height="24"
    >
      <path
        d="M1,7h23c0.6,0,1,0.4,1,1s-0.4,1-1,1H1C0.4,9,0,8.6,0,8S0.4,7,1,7z M1,0h23c0.6,0,1,0.4,1,1s-0.4,1-1,1H1   C0.4,2,0,1.6,0,1S0.4,0,1,0z M1,14h23c0.6,0,1,0.4,1,1s-0.4,1-1,1H1c-0.6,0-1-0.4-1-1S0.4,14,1,14z"
        fill={color}
      />
    </svg>
  );
};

HamburgerIcon.propTypes = {
  color: PropTypes.string,
};

export default HamburgerIcon;
